
import Button from './common/Button.vue';
import SectionHeader from './common/SectionHeader.vue';
import Swiper from './common/Swiper.vue';
import { reachGoal } from './utils/metrika.js';

export default {
  name: 'MeatPageCatalog',
  components: { SectionHeader, Swiper, Button },
  props: {
    data: {
      type: Object,
      required: true
    },
    common: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeFilters: {
        country: 'all',
        processing: 'all',
        sort: 'asc'
      },
      isProcessingOpen: false,
      isSortOpen: false
    };
  },
  
  computed: {
    availableCountries() {
      const list = [{ value: 'all', label: this.data.translations?.allCountries, sort: 0 }];

      if (!this.data?.items) return list;

      const presentCountryKeys = new Set(
        this.data.items.map(item => item.country).filter(Boolean)
      );

      if (this.data.countryIcons) {
        Object.entries(this.data.countryIcons).forEach(([key, iconData]) => {
          if (presentCountryKeys.has(key)) {
            list.push({
              value: key,
              label: iconData.name || key,
              sort: iconData.sort ?? 999
            });
            presentCountryKeys.delete(key); 
          }
        });
      }

      presentCountryKeys.forEach(key => {
        const itemWithCountry = this.data.items.find(i => i.country === key);
        const countryStat = itemWithCountry?.stats?.find(s => s?.key === 'country');

        list.push({
          value: key,
          label: countryStat?.value || key,
          sort: 999
        });
      });

      return list.sort((a, b) => a.sort - b.sort);
    },

   processingOptions() {
    const options = [];

    // 1. Сначала собираем конкретные опции
    if (this.data.translations?.chilled) {
      options.push({ value: 'chilled', label: this.data.translations.chilled });
    }

    if (this.data.translations?.frozen) {
      options.push({ value: 'frozen', label: this.data.translations.frozen });
    }

    // 2. Если есть хотя бы одна опция (chilled или frozen), добавляем "Все" в НАЧАЛО массива
    if (options.length > 0 && this.data.translations?.allProcessing) {
      options.unshift({ value: 'all', label: this.data.translations.allProcessing });
    }

    return options;
  },

    sortOptions() {
      const options = [];
    
      if (this.data.translations?.sortAsc) {
        options.push({ value: 'asc', label: this.data.translations.sortAsc });
      }
      if (this.data.translations?.sortDesc) {
        options.push({ value: 'desc', label: this.data.translations.sortDesc });
      }

      return options;
    },

    currentProcessingLabel() {
      const activeOption = this.processingOptions.find(o => o.value === this.activeFilters.processing);
      return activeOption ? activeOption.label : (this.processingOptions[0]?.label || '');
    },

    currentSortLabel() {
      const activeOption = this.sortOptions.find(o => o.value === this.activeFilters.sort);
      return activeOption ? activeOption.label : (this.sortOptions[0]?.label || '');
    },

    filteredItems() {
      if (!this.data?.items) return [];

      let items = [...this.data.items];

      if (this.activeFilters.country !== 'all') {
        items = items.filter(item => item.country === this.activeFilters.country);
      }

      if (this.activeFilters.processing !== 'all') {
        items = items.filter(item => item.processing === this.activeFilters.processing);
      }

      const activeSort = this.sortOptions.some(o => o.value === this.activeFilters.sort)
        ? this.activeFilters.sort
        : (this.sortOptions[0]?.value || 'asc');

      items.sort((a, b) => {
        const priceA = Number(a.price) || 0;
        const priceB = Number(b.price) || 0;
        return activeSort === 'asc' ? priceA - priceB : priceB - priceA;
      });

      return items;
    },

    swiperOptions() {
      const realCount = this.filteredItems.length;
      return {
        slidesPerView: 4,
        spaceBetween: 12,
        loop: realCount > 4,
        autoplay: {
          enabled: realCount > 4,
          speed: 6000,
        },
        navigation: {
          enabled: true
        },
        pagination: {
          clickable: true,
          renderBullet: (index, className) => {
            if (index >= realCount) return '';
            return `<span class="${className}"></span>`;
          }
        },
        breakpoints: { 
          0: { 
            slidesPerView: 1,
          },
          1025: { 
            slidesPerView: 4,
          } 
        },
        on: {
          navigationNext: () => this.reachGoal('click_catalog_mobile_carousel_next'),
          navigationPrev: () => this.reachGoal('click_catalog_mobile_carousel_prev'),
          slideChange: (swiper) => {
            if (realCount === 0) return;
            const realIndex = swiper.realIndex % realCount;
            const bullets = swiper.pagination.bullets;
            bullets.forEach((bullet, i) => {
              bullet.classList.toggle('hide', i > realIndex + 4 || i < realIndex - 4);
              bullet.classList.toggle('swiper-pagination-bullet-active', i === realIndex);
            });
          }
        }
      };
    }
  },
  created() {
    if (this.sortOptions.length > 0 && !this.sortOptions.some(o => o.value === this.activeFilters.sort)) {
      this.activeFilters.sort = this.sortOptions[0].value;
    }
  },

  mounted() {
    document.addEventListener('click', this.closeSelectsOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeSelectsOutside);
  },
  methods: { 
    reachGoal,
    formatPrice(product) {
      if (product.button?.title) return product.button.title;
      if (product.price === undefined) return '';

      const formattedNumber = product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      const unit = product.unit || 'сум/кг';
      
      return `${formattedNumber} ${unit}`;
    },
    // Выбор обработки
    selectProcessing(value) {
      this.activeFilters.processing = value;
      this.isProcessingOpen = false;
    },
    // Выбор сортировки
    selectSort(value) {
      this.activeFilters.sort = value;
      this.isSortOpen = false; 
    },
    closeSelectsOutside(event) {
      if (this.$refs.processingSelect && !this.$refs.processingSelect.contains(event.target)) {
        this.isProcessingOpen = false;
      }
      // Проверяем клик для селекта сортировки
      if (this.$refs.sortSelect && !this.$refs.sortSelect.contains(event.target)) {
        this.isSortOpen = false;
      }
    }
  }
}
